var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-details-page",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"header",class:{'resume-pack-up': _vm.packUp}},[_c('search'),_c('info',{staticClass:"pack-up-margin"}),_c('menus',{staticClass:"pack-up-margin"})],1),_c('div',{ref:"content",staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }